import { createFileRoute } from '@tanstack/react-router';

import { IntegrationEditorPage } from '../features/demand/integrations/components/IntegrationEditorPage/IntegrationEditorPage';

export const Route = createFileRoute('/demand/integrations/edit/$demandPartnerId/$integrationId')({
  component: IntegrationEditRoute,
});

function IntegrationEditRoute() {
  const { demandPartnerId, integrationId } = Route.useParams();
  return <IntegrationEditorPage demandPartnerId={demandPartnerId} integrationId={integrationId} />;
}
